export const sessionStorageKeys = {
  chatOpenedBefore: 'chatOpenedBefore',
};

export const localStorageKeys = {
  showMaiaOnInit: 'showMaiaOnInit',
};
